import moment from "moment";
import React, { useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import SelectDropDown from "../../../shared/drop-down/drop-down";

const PricingTemplate = ({
    Template_list,
    showAddTemplateModal,
    deleteTemplate,
    editTemplate,
    organizationId,
    updateTemplateCount,
    showAddTemplate,
    handleOrgChange,
    handleUserChange,
    resetOrgValue,
    resetUserValue,
    handleSearchKeyChange,
    isPcAdmin,
    userData,
    org_options,
    user_options,
    selected_org_id,
    selected_user_id,
    resetAllFilter,
}) => {
    const filterType = "pricing";
    const [templates, setTemplateList] = useState(Template_list);
    const [searchValue, setSearchedValue] = useState("");
    useEffect(() => {
        setTemplateList(Template_list);
        updateTemplateCount(Template_list.length);
    }, [Template_list, showAddTemplate]);

    useEffect(() => {
        handleSearchKeyChange(searchValue, filterType);
    }, []);

    const handleKeyWordChange = (evt) => {
        let value = evt.target.value;
        setSearchedValue(value);
        handleSearchKeyChange(value, filterType);
    };

    const handleSearchClick = (evt) => {
        evt.preventDefault();
        if (searchValue !== "") handleSearchKeyChange(searchValue, filterType);
    };

    const handleKeyPress = (evt) => {
        if (evt.key === "Enter") {
            evt.preventDefault();
        }
    };

    const handleTemplateDelete = (evt) => {
        confirmAlert({
            title: "Delete Template",
            message: "Are you sure you want to delete the Template?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        deleteTemplate(evt);
                        setSearchedValue("");
                    },
                },
                {
                    label: "No",
                },
            ],
        });
    };

    return (
        <>
            <div className="panel-heading" id="pannel-headingId">
                <div className="header-search">
                    <form>
                        <input
                            value={searchValue}
                            type="text"
                            placeholder="Search Template"
                            name="search"
                            className="search-box"
                            onChange={(evt) => handleKeyWordChange(evt)}
                            onKeyPress={(evt) => handleKeyPress(evt)}
                        />
                        <button onClick={(e) => handleSearchClick(e)}>
                            <i className="fa fa-search"></i>
                        </button>
                    </form>
                    <div className="templete-dropdown-filter">
                        {isPcAdmin === true && (
                            <div className="org-dropdown">
                                <SelectDropDown
                                    isSearchable={true}
                                    options={org_options}
                                    name="filter_by_organization"
                                    placeholder="Search by organization"
                                    value={selected_org_id}
                                    handleChange={(selected) => {
                                        if (selected != null) {
                                            handleOrgChange(
                                                selected.value,
                                                filterType,
                                            );
                                        }
                                    }}
                                    clearValue={true}
                                    templateReset={() =>
                                        resetOrgValue(filterType)
                                    }
                                />
                            </div>
                        )}
                        <div className="user-dropdown">
                            {(isPcAdmin === true || userData.role == "admin") &&
                                selected_org_id && (
                                    <SelectDropDown
                                        isSearchable={true}
                                        options={user_options}
                                        name="filter_by_user"
                                        placeholder="Search by user"
                                        value={selected_user_id}
                                        handleChange={(selected) => {
                                            if (selected != null) {
                                                handleUserChange(
                                                    selected.value,
                                                    filterType,
                                                );
                                            }
                                        }}
                                        clearValue={true}
                                        templateReset={() =>
                                            resetUserValue(filterType)
                                        }
                                    />
                                )}
                        </div>
                    </div>
                </div>
                <div className="d-flex">
                    <button
                        onClick={() => {
                            setSearchedValue("");
                            showAddTemplateModal();
                            setTemplateList(Template_list);
                        }}
                        className="orgbtn"
                    >
                        <i className="fa fa-create"></i> Add Template
                    </button>
                </div>
            </div>
            <div className="table-organizations table-templates">
                {templates && templates.length > 0 ? (
                    <table
                        className="table table-striped table-responsive template-list"
                        id="template-index-table"
                    >
                        <thead>
                            <tr>
                                <th className="TemplateTitle">Template Name</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {templates.map((template, index) => (
                                <tr key={"tr" + index}>
                                    <td className="TemplateName">
                                        <div className="org-full-name">
                                            <h4>
                                                {template.pricing_template_name}
                                            </h4>
                                        </div>
                                    </td>
                                    <td className="addresidual template-add-delete">
                                        <span
                                            onClick={(evt) => {
                                                setSearchedValue("");
                                                editTemplate(template);
                                            }}
                                        >
                                            Edit
                                        </span>

                                        {isPcAdmin === true ||
                                        userData.role == "admin" ||
                                        userData.id == template.created_by ? (
                                            <span
                                                onClick={(evt) =>
                                                    handleTemplateDelete(
                                                        template,
                                                    )
                                                }
                                                className="addresidualIMG"
                                            >
                                                <img src="/images/delet.svg " />
                                            </span>
                                        ) : (
                                            <span className="addresidualIMG cursor-not-allowed">
                                                <img src="/images/delet.svg " />
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <p className="no-data text-center"> No Templates found</p>
                )}
            </div>
        </>
    );
};

export default PricingTemplate;
